import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { payment, paymentverify } from './api';

const initialState = {
  loading: false,
  payment_details: [],
  details_payment: []
};

const actions = {
  PAYMENTWAY: 'paymentway/PAYMENTWAY',
  VERIFYAPI: 'verifyAPI/VERIFYAPI'
};

export const paymentway = createAsyncThunk(
  actions.PAYMENTWAY,
  async (payload) => {
    const response = await payment(payload);
    return response;
  }
);
// verifyAPI/VERIFYAPI
// export const verifyAPI = createAsyncThunk(
//   actions.VERIFYAPI,
//   async (payload) => {
//     const response = await paymentverify(payload);
//     return response;
//   }
// );

export const verifyAPI = createAsyncThunk(
  'payment/verifyAPI',
  async (paymentData, { rejectWithValue }) => {
    try {
      const response = await paymentverify(paymentData);
      console.log('verifyAPI response', response);
      const { payment_id, invoice_id } = response.data;
      localStorage.setItem(
        'payment_profile_id',
        JSON.stringify({ payment_id, invoice_id })
      );
      return response; // Adjust based on your API's response structure
    } catch (error) {
      // Return a rejected action with the error message
      return rejectWithValue(error.response.data);
    }
  }
);

export const PaymentwaySlice = createSlice({
  name: 'paymentgateway',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(paymentway.pending, (state) => {
        state.loading = true;
      })
      .addCase(paymentway.fulfilled, (state, action) => {
        const { order, success } = action.payload;
        console.log('data', action.payload);
        state.loading = false;
        state.payment_details = order;
        state.success = success;
      })
      .addCase(paymentway.rejected, (state) => {
        state.loading = false;
      });

    // verifyAPI
    builder
      .addCase(verifyAPI.pending, (state) => {
        state.loading = true;
      })
      .addCase(verifyAPI.fulfilled, (state, action) => {
        const { order, success } = action.payload;
        console.log('verifyAPI data', action.payload);
        state.loading = false;
        state.details_payment = order;
        // localStorage.getItem('payment_details', order);
        state.success = success;
      })
      .addCase(verifyAPI.rejected, (state) => {
        state.loading = false;
      });
  }
});

export default PaymentwaySlice.reducer;
